import styled from 'styled-components';
import { Box } from '@mui/material';

export const EventpageSec = styled.div`
	color: black;
	padding: 0px;
	margin-top: -10px;
	
`;

export const BoxContainer = styled(Box)`
	position: relative;
	background: linear-gradient(to right, #cce2ff 50%, #2376e5 90%) !important;
	height: 100vh;
	box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
	padding-bottom: 150px;
`;

export const Container = styled.div`
	z-index: 1;
	width: 100%;
	max-width: 1300px;
	margin-right: auto;
	margin-left: auto;
	padding-right: 50px;
	padding-left: 50px;

	@media screen and (max-width: 768px) {
		padding-right: 10px;
		padding-left: 10px;
	}
`;

export const Header1 = styled.h1`
	font-size: 35px;
	font-family: 'Open Sans', sans-serif;
	margin-left: 4vw;
	margin-top:-5px;
	padding-top:150px ;
`;
export const Header = styled.h1`
	font-size: 35px;
	font-family: 'Open Sans', sans-serif;
	margin-left: 4vw;

`;

export const NoEvents = styled.p`
	font-size: 18px;
	font-family: 'Open Sans', sans-serif;
	margin-left: 4vw;
	height: 120px;
	width: 100%;
`;


// PopupBox
export const PopupBox = styled(Box)`
	position: relative;
	background: linear-gradient(to right, #cce2ff 50%, #2376e5 90%) !important;
	width: auto;
	background-color: #ffffff;
	border-radius: 35px;
	border: 1px solid #707070;
	box-shadow: 0px 0px 25px rgb(0 0 0 / 16%);
	padding: 80px 8vw;
	margin: 40px;
	margin-top: 130px;
`;

export const CloseMark = styled.span`
	color: rgb(0, 204, 255);
	float: right;
	font-size: 32px;
	font-weight: bold;
	overflow: auto; 
`;

export const ModalBox = styled(Box)`
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	align-items: center;
	overflow: auto;
`;

export const EventHeader = styled.div`
	width: 100%;
	margin-bottom: 50px;
`;

export const EventTitle = styled.h1`
	/* padding: 100px 0; */
	margin-left: auto;
	margin-right: auto;
	/* color: white; */
	font-family: 'Segoe UI', 'Arial';
`;

export const EventInfo = styled.div`
	font-family: 'Segoe UI', 'Arial';
	font-size: 18px;
	align-self: flex-start;
`;

export const EventButton = styled.div`
	position: relative;
	margin: auto;
	padding: 12px 18px;
	transition: all 0.2s ease;
	border: none;
	background: none;
`;




